// web/src/tutorial/quickstart/index.ts
// Quick Start 文档注册表。顺序 = 页面「上一篇 / 下一篇」的顺序，也与产品矩阵一致。
//
// 定位（2026-09 起）：**最短流程** —— 基本不动参数，选演奏者 → 选 MIDI → 生成动画。
// 每个界面上每个可调参数的说明在「软件界面详细说明」那一类里（src/tutorial/detail/），
// 两类页面共用同一批截图，但功能不同，所以分开成两类文档。

import type { TutorialDoc } from "../types";
import { beatBloomQuickstart } from "./beat-bloom";
import { fretDanceQuickstart } from "./fret-dance";
import { harpGlideQuickstart } from "./harp-glide";
import { keyRippleQuickstart } from "./key-ripple";
import { stringFlowQuickstart } from "./string-flow";
import { windRiseQuickstart } from "./wind-rise";
import { zhengDriftQuickstart } from "./zheng-drift";

export const QUICKSTART_DOCS: TutorialDoc[] = [
  keyRippleQuickstart,
  stringFlowQuickstart,
  fretDanceQuickstart,
  beatBloomQuickstart,
  zhengDriftQuickstart,
  harpGlideQuickstart,
  windRiseQuickstart,
];
